import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import 'animate.css';
import Vue from 'vue';
import Vuetify, { VRow, VList } from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VRow,
    VList
  }
});

import en from 'vuetify/es5/locale/en';
import de from 'vuetify/es5/locale/de';
import fr from 'vuetify/es5/locale/fr';
import it from 'vuetify/es5/locale/it';

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#64b43c',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    },
    icons: {
      iconfont: 'mdi' // default - only for display purposes
    }
  },
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { en, de, fr, it },
    current:
      localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || 'de'
  }
});
